module.exports = __webpack_public_path__ + "img/3.ead19260.svg";